<!--
  A separate element per state, each with its own static tid. TestIdDirective stamps once in
  ngAfterViewInit, so a single card with a bound [tid] would keep whichever value it first
  rendered with and the other state's tid would never reach the DOM.
-->
@switch (state()) {
  @case ('pre-move') {
    <div class="domain-migration-notice" tid="domain-migration-notice">
      <p class="ci-text-lg--bold domain-migration-notice__heading">We're moving to {{ newDomainLabel }}</p>

      <div class="domain-migration-notice__body">
        <p class="ci-text-sm">
          From <strong class="ci-text-sm--bold">{{ dateLabel }}</strong
          >, {{ oldDomainLabel }} will become {{ newDomainLabel }}.
        </p>
        <p class="ci-text-sm">On that date, you'll need to update any saved logins, bookmarks, or passkeys to keep access.</p>
        <a
          class="ci-text-sm domain-migration-notice__link"
          [href]="helpUrl"
          target="_blank"
          rel="noopener noreferrer"
          tid="domain-migration-notice-help-link"
          >{{ helpLinkLabel }}</a
        >
      </div>
    </div>
  }
  @case ('post-move') {
    <div class="domain-migration-notice" tid="domain-migration-post-move-notice">
      <p class="ci-text-lg--bold domain-migration-notice__heading">You are in the right place!</p>

      <div class="domain-migration-notice__body">
        <p class="ci-text-sm">
          On <strong class="ci-text-sm--bold">{{ dateLabel }}</strong> {{ oldDomainLabel }} moved to {{ newDomainLabel }}.
        </p>
        <p class="ci-text-sm">
          If you have not yet done it, please update saved login details and passkeys. Please see here for more information.
        </p>
        <a
          class="ci-text-sm domain-migration-notice__link"
          [href]="helpUrl"
          target="_blank"
          rel="noopener noreferrer"
          tid="domain-migration-post-move-notice-help-link"
          >{{ helpLinkLabel }}</a
        >
      </div>
    </div>
  }
}
